/* global Glide */
/**
 * 
 * 
 * Reference:
 * https://codepen.io/juanbrujo/pen/KJdst?editors=0010
 * https://glidejs.com/
 * https://glidejs.com/docs/api/
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video
 * https://css-tricks.com/full-page-background-video-styles/
 * https://codepen.io/dudleystorey/pen/knqyK
 */

document.addEventListener("DOMContentLoaded", function() {

  var bgImageSliders = document.querySelectorAll('.bg-image-slider');
  
  for (let i = 0; i < bgImageSliders.length; i++) {

    /**
     * Enable the slider.
     */
    (function(slider){
      
      var slideID = 'bgimageslide'+String(i);
      slider.setAttribute('id',slideID);

      var bgSlider = new Glide('#'+slideID, {
        type: 'slider',
		rewind: false,
        perView: 1,
      });

      bgSlider.on('run', function() {
		var left = 	document.querySelector('#'+slideID+' .glide__arrow--left');
		var right = document.querySelector('#'+slideID+' .glide__arrow--right');

		if (left) {
			if (bgSlider.index === 0) {
				left.setAttribute('data-disabled', 'true');
			} else {
				left.setAttribute('data-disabled', 'false');
			}
		}

		if (right) {
			var track_length = document.querySelectorAll(('#')+slideID+' ul li.glide__slide').length;
			if (bgSlider.index === (track_length - 1)) {
				right.setAttribute('data-disabled', 'true');
			} else {
				right.setAttribute('data-disabled', 'false');
			}
		}
	});
      
      bgSlider.mount();

    })(bgImageSliders[i]);
  }

});